import React from 'react'
import { Search } from '@material-ui/icons'
import { useDebouncedCallback } from 'use-debounce'
import { StyledInputAdornment, StyledSearchField, svgIconStyle, colors } from '../../../../../theme/Global'
import { TableSearchContainer } from './styles'

const SearchComponent = ({ showExport, showExportDropdown, isLoading, eventHandlers }) => {
  const [debouncedCallback] = useDebouncedCallback((value) => {
    eventHandlers.setSearchText(value)
    eventHandlers.setPageNumber(1)
  }, 800)

  const getContainerSize = () => {
    if (showExport) return 8
    if (showExportDropdown) return 6
    return 12
  }

  return (
    <TableSearchContainer item xs={getContainerSize()}>
      <StyledSearchField
        disabled={isLoading}
        placeholder="Search"
        onChange={(e) => debouncedCallback(e.target.value)}
        margin="dense"
        InputProps={{
          'data-testid': 'search-input',
          disableUnderline: true,
          endAdornment: (
            <StyledInputAdornment position="start">
              <Search
                style={svgIconStyle({
                  color: colors.mediumGrey,
                  height: '30px',
                  width: '30px'
                })}
              />
            </StyledInputAdornment>
          )
        }}
        style={{
          margin: '0 auto',
          padding: '0'
        }}
      />
    </TableSearchContainer>
  )
}

export default SearchComponent
